import React from 'react';
import { EINSTELLUNGEN } from '../../config/ebenen';
import { Bereich } from './Bereich';

// DR-13 (UI-01): scheitert ein Bereich beim Zeichnen, sagt das Pop-up das an seiner Stelle; Navigation, Schließen und die
// Anwendung dahinter bleiben bedienbar. „Erneut versuchen“ zeichnet den Bereich neu, ein Wechsel der Adresse ebenso;
// fehlte ein nachgeladener Teil der Anwendung (lazy), lädt es die Seite neu, weil React den Import nicht wiederholt.
export const SEITE_FEHLT = 'Diese Seite konnte nicht geladen werden.';
// Meldungen der Browser für einen gescheiterten dynamischen Import (Chromium, Firefox, Safari) und für fehlendes CSS (Vite).
const NACHLADEN_FEHLT = /dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export class Fehlergrenze extends React.Component<{ adresse: string; children?: React.ReactNode }, { fehler: boolean; nachladen: boolean }> {
  state = { fehler: false, nachladen: false };
  static getDerivedStateFromError(error: unknown) { return { fehler: true, nachladen: error instanceof Error && NACHLADEN_FEHLT.test(error.message) }; }
  componentDidUpdate(vorher: { adresse: string }) {
    if (this.state.fehler && vorher.adresse !== this.props.adresse) this.setState({ fehler: false });
  }
  render() {
    if (!this.state.fehler) return this.props.children;
    return <Bereich titel={EINSTELLUNGEN.titel}>
      <p className="adm-error" role="alert">{SEITE_FEHLT}</p>
      <div className="einst-formular-aktionen"><button type="button" className="adm-button" onClick={() => this.state.nachladen ? window.location.reload() : this.setState({ fehler: false })}>{EINSTELLUNGEN.erneutVersuchen}</button></div>
    </Bereich>;
  }
}
